<template>
  <div class="baseMultiSelectItem">
    <input
      type="checkbox"
      :id="value"
      :name="label"
      :value="selectedItems"
      :checked="isSelected"
    />
    <label
      :for="value"
      tabindex="0"
      role="checkbox"
      @click="handleClick"
      @keydown="handleKeyDown($event)"
      :aria-checked="isSelected"
    >
      <p>
        <slot></slot>
      </p>
    </label>
  </div>
</template>

<script>
const SPACEBAR = 32;

export default {
  props: {
    value: {
      required: true,
      type: Number,
    },
    label: {
      required: true,
      type: String,
    },
  },
  computed: {
    classObject: function () {
      return {
        selected: this.isSelected,
      };
    },

    isSelected: function () {
      const { value: allValues } = this.getMultiSelectState();
      return allValues.includes(this.value);
    },

    selectedItems: function () {
      const { value: allValues } = this.getMultiSelectState();
      return allValues;
    },
  },

  methods: {
    handleClick(e) {
      const { toggle } = this.getMultiSelectState();
      toggle(this.value);
      e.preventDefault();
    },

    handleKeyDown(event) {
      if (event.keyCode === SPACEBAR) {
        this.handleClick();
        event.preventDefault();
      }
    },
  },
  inject: ["getMultiSelectState"],
};
</script>

<style lang="scss" scoped>
@import "~@web-components/scss/components/_baseMultiSelectItem.scss";
</style>
